import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import { FlexType } from '@sdk/components/ui/spacing/FlexCss';

const PurchaseColumn = styled(Column)<{ isSingleColumn?: boolean } & FlexType>`
  background-color: ${({ theme }): string => theme.colors.white};
  padding: ${({ isSingleColumn }) => (isSingleColumn ? '40px 75px' : '20px')};
  ${({ isSingleColumn }) => (isSingleColumn ? 'width: 580px' : '')};
`;

export default PurchaseColumn;
